<template>
  <div :class="{ header: true, fixs: isFixeds }">
    <div :class="{ center: true, clearfix: true, bigheader: isbig }">
      <h1 class="fl">
        <router-link to="/">
          <img v-show="!isFixeds" src="~img/authorlogo.png" alt="logo" />
          <img v-show="isFixeds" src="~img/logo@2x.png" alt="logo" />
        </router-link>
      </h1>
      <ul class="nav-left fl">
        <li v-for="(item, index) in nav_left" :key="item.name">
          <router-link v-if="index !== 5" :to="item.url"
            >{{ item.name }} <span class="line"></span
          ></router-link>
          <a v-if="index == 5" target="_blank" :href="item.url">{{
            item.name
          }}</a>
        </li>
      </ul>
      <ul class="nav-right fr">
        <li>
          <div class="search">
            <input
              type="text"
              id="search"
              v-model="searchValue"
              @keyup.enter="goBoxValue"
              placeholder="书名/作者名"
            />
            <img src="~img/search.png" @click="goBoxValue" alt="" />
          </div>
        </li>
        <li
          class="loginsmall"
          @mouseenter="seeOption"
          @mouseleave="canaleoPtion"
        >
          <div v-if="token !== null" class="myheaderimg" @click="goCenter">
            <img :src="imgURL + imgurl.iconUrlSmall" alt="" />
          </div>
          <div v-else class="nologin" style="text-align: center">
            <a href="javaScript:" @click="phoneLogin">登录</a>
            <!-- |
            <a href="javaScript:" @click="goRegister">注册</a> -->
          </div>
          <div class="right" v-show="isShowRight">
            <div class="not-login" v-show="isshowInfo">
              <img class="notBg" src="~img/account/list_bg.png" alt="" />
              <template v-if="token == null">
                <a
                  href="javaScript:"
                  class="signin clearfix"
                  @click="phoneLogin"
                >
                  <img class="fl" src="~img/account/phone.png" /><span
                    class="fl"
                    >快捷登录</span
                  >
                </a>
                <a href="javaScript:" class="signin clearfix" @click="gologin">
                  <img class="fl" src="~img/account/userlogin.png" /><span
                    class="fl"
                    >账户登录</span
                  >
                </a>
                <a :href="qqurl" class="third clearfix"
                  ><img class="fl" src="~img/account/qq.png" /><span class="fl"
                    >QQ登录</span
                  ></a
                >
                <a :href="weixinLogin" class="third"
                  ><img class="fl" src="~img/account/weixin.png" /><span
                    class="fl"
                    >微信登录</span
                  ></a
                >
              </template>
              <template v-else>
                <routerLink to="/personal/collect"
                  ><img class="fl" src="~img/account/sc@2x.png" /><span
                    class="fl"
                    >我的收藏</span
                  ></routerLink
                >
                <routerLink to="/personal/center"
                  ><img class="fl" src="~img/account/zh@2x.png" /><span
                    class="fl"
                    >我的账户</span
                  ></routerLink
                >
                <routerLink to="/personal/message" class="notice">
                  <img class="fl" src="~img/account/xx@2x.png" />
                  <span class="fl">消息通知</span>
                  <!-- <span class="count"><em>1</em></span> -->
                </routerLink>
                <a href="javascript:" @click="logout">
                  <img class="fl" src="~img/account/zh@2x.png" /><span
                    class="fl"
                  >
                    退出</span
                  >
                </a>
              </template>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getToken } from "utils/storage";
import { mapState } from "vuex";
import { BENDI } from "apiurl/index.js";
export default {
  props: {
    isbig: {
      type: Boolean,
      default: false
    },
    isAuthor: Boolean
  },
  data() {
    return {
      nav_left: [
        {
          name: "首页",
          url: "/"
        },
        /*  {
                  name: "排行榜",
                  url: "/personal/center"
                }, */
        {
          name: "书库",
          url: "/bookStack"
        },
        {
          name: "出版",
          url: "/publishBook"
        }
      ],
      nav_right: [
        {
          name: "个人中心",
          url: "/personal/center"
        },
        {
          name: "作家中心",
          url: "/author"
        }
      ],
      currentRouter: {},
      qqurl: "",
      weixinLogin: "",
      isFixeds: false,
      isshowInfo: true,
      isShowRight: false,
      token: getToken() || null,
      searchValue: null
    };
  },
  methods: {
    gologin() {
      if (!getToken()) {
        this.$router.push({
          path: "/login",
          query: { redirect: this.$route.path }
        });
      }
    },
    goRegister() {
      this.$router.push({
        path: "/register",
        query: { redirect: this.$route.path }
      });
    },
    goCenter() {
      this.$router.push({
        path: "/personal/center",
        query: { redirect: this.$route.path }
      });
    },
    phoneLogin() {
      if (!getToken()) {
        this.$router.push({
          path: "/phoneLogin",
          query: { redirect: this.$route.path }
        });
      }
    },
    /* 退出 */
    logout() {
      this.$store
        .dispatch("LogOut")
        .then(res => {
          if (res.success) {
            this.$router.push({
              path: "/login",
              query: "/"
            });
          }
        })
        .catch(() => {});
    },
    // ==吸顶
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 210) {
        //提前判断要上升多少像素就固定
        this.isFixeds = true;
      } else {
        this.isFixeds = false;
      }
    },
    seeOption() {
      this.isShowRight = true;
    },
    canaleoPtion() {
      this.isShowRight = false;
    },
    goBoxValue() {
      this.$router.push({
        path: "/bookStack",
        query: { searchValue: this.searchValue }
      });
      this.searchValue = null;
    }
  },
  computed: mapState({
    imgurl: state => state.user.img
  }),
  created() {
    // console.log(this.imgurl);
  },
  mounted() {
    let backUrl = "/";
    if (this.$route.query.redirect) {
      backUrl = this.$route.query.redirect;
    }
    this.qqurl = `${BENDI}/third/auth/login?thirdType=2&backUrl=${backUrl}`;
    this.weixinLogin = `${BENDI}/third/auth/login?thirdType=3&backUrl=${backUrl}`;
    if (this.$route.path == "/") {
      window.addEventListener("scroll", this.handleScroll);
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/styles/cominxin.styl'
.router-link-exact-active
    color #48A2DF
    .line
        width 34px
        height 3px
        background rgba(72, 162, 223, 1)
        border-radius 4px
        position absolute
        bottom 25px
        left 50%
        margin-left -17px
        display inline-block
input
    border none
    outline none
.header
    width 100%
    background #fff
    &.fixs
        background #191F45
        position fixed
        z-index 200
        top 0
        left 0
        height 64px
        .center
            color #fff
            height 64px
            line-height 64px
            .nav-right, .nav-left
                li
                    a
                        color #D5DEE5
                    &.loginsmall
                        .nologin
                            a
                                color #fff
                        .myheaderimg
                            img
                                top 12px
                    .search
                        margin-top 13.5px
                        color #48A2DF
                .router-link-exact-active
                    color #48A2DF
                    .line
                        bottom 12px
                .right
                    .not-login
                        top 64px
            h1
                width 124px
                height 29px
                margin-top 9px
                margin-left 0px
    .center
        width 1200px
        position relative
        margin 0 auto
        height 84px
        line-height 84px
        font-size 16px
        font-family PingFangSC-Regular
        font-weight 400
        color #333333
        &.bigheader
            width 1200px
        h1
            width 250px
            height 53px
            display inline-block
            line-height normal
            margin 15px 30px 0 0
            img
                width 100%
                height 100%
        .nav-left, .nav-right
            height 84px
            li
                display inline-block
                padding 0 22px
                position relative
                &.loginsmall
                    position absolute
                    width 70px
                    right 0px
                    height 100px
                    cursor pointer
                    padding 0
                    a
                        font-size 14px
                a
                    display inline-block
                    color #333333
                    &.router-link-exact-active
                        color #48A2DF
                    &:hover
                        color: #48a2df;
        .nav-left
            margin-right 20px
        .nav-right
            margin-right 120px
            li
                padding 0 9px
                .search
                    width 187px
                    height 37px
                    background rgba(238, 240, 242, 1)
                    box-sizing border-box
                    border-radius 24px
                    margin-top 23px
                    position relative
                    input
                        width 146px
                        margin-top 0
                        height 37px
                        background rgba(238, 240, 242, 1)
                        box-sizing border-box
                        vertical-align top
                        border-radius 24px
                        font-size 14px
                        padding-left 15px
                        placeMain(#AFAFCB, 16px, 25px)
                    img
                        position absolute
                        width 19px
                        height 18px
                        top 10px
                        right 16px
            a
                font-size 14px
                font-family PingFangSC-Regular
            .nologin
                font-size 14px
            .myheaderimg
                img
                    width 40px
                    height 40px
                    border-radius 50%
                    display block
                    margin 0
                    position absolute
                    top 22px
                    left 12px
            .right
                .not-login
                    width 107px
                    box-sizing border-box
                    padding 12px 13px 10px 16px
                    position absolute
                    top 83px
                    right 0px
                    z-index 10
                    .notBg
                        position absolute
                        top -18px
                        left -4px
                        height 164px
                        width 123px
                        z-index -1
                    a
                        text-align center
                        display block
                        font-size 14px
                        font-family PingFangSC-Regular
                        font-weight 400
                        color #555555
                        border-bottom 1px dashed rgba(255, 255, 255, 1)
                        margin-bottom 10px
                        height 14px
                        line-height 14px
                        padding 3px 0
                        img
                            width 14px
                            height 14px
                            margin-right 8px
                        span
                            font-size 14px
                            height 14px
                            line-height 14px
                            display inline-block
                            &:hover
                                color #48a2df
                    .notice
                        position relative
                        .count
                            position absolute
                            width 14px
                            height 14px
                            font-size 12px
                            border-radius 50%
                            background #48A2DF
                            color #fff
                            text-align center
                            line-height 15px
                            top -5px
                            right -9px
</style>
